import { render, staticRenderFns } from "./StonePowerRankLegend.vue?vue&type=template&id=183a6284&scoped=true"
import script from "./StonePowerRankLegend.vue?vue&type=script&lang=js"
export * from "./StonePowerRankLegend.vue?vue&type=script&lang=js"
import style0 from "./StonePowerRankLegend.vue?vue&type=style&index=0&id=183a6284&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183a6284",
  null
  
)

export default component.exports